import React, { useEffect, useRef } from 'react';

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const footer = footerRef.current;

    const handleMouseMove = (e) => {
      const { left, top, width, height } = footer.getBoundingClientRect();
      const x = ((e.clientX - left) / width) * 100;
      const y = ((e.clientY - top) / height) * 100;
      footer.style.setProperty('--x', `${x}%`);
      footer.style.setProperty('--y', `${y}%`);
      footer.style.background = `radial-gradient(circle at ${x}% ${y}%, #ff4081, #3f51b5)`;
    };

    footer.addEventListener('mousemove', handleMouseMove);

    return () => {
      footer.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <footer ref={footerRef} className="footer-container">
      <div className="container">
        <section className="footer-section">
          <div className="row text-center d-flex justify-content-center pt-3">
            <div className="col-md-2">
              <h6 className="text-uppercase font-weight-bold">
                <a href="/about" className="footer-links">About us</a>
              </h6>
            </div>
            <div className="col-md-2">
              <h6 className="text-uppercase font-weight-bold">
                <a href="/team" className="footer-links">Team</a>
              </h6>
            </div>
            <div className="col-md-2">
              <h6 className="text-uppercase font-weight-bold">
                <a href="#!" className="footer-links">Careers</a>
              </h6>
            </div>
            <div className="col-md-2">
              <h6 className="text-uppercase font-weight-bold">
                <a href="#!" className="footer-links">Help</a>
              </h6>
            </div>
            <div className="col-md-2">
              <h6 className="text-uppercase font-weight-bold">
                <a href="#!" className="footer-links">Contact</a>
              </h6>
            </div>
          </div>
        </section>
        
        <hr className="my-5" />
        
        <section className="footer-section">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
              <p>
                At Care Connect, We Bridge the Gap Between You and Exceptional Healthcare – Ensuring Personalized, Compassionate Care for a Brighter, Healthier Future.
              </p>
            </div>
          </div>
        </section>      
      </div>

      <div className="footer-bottom text-center p-3">
         Copyright © 2023 Care Connect. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
